import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import Time from "../../../Time/Time";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import EventUpdateWillMount from "../../../Middleware/Middlewares/EventUpdateWillMount";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import { Timeline } from "../../Partials/Timeline/Timeline";
import { Property } from "../../../Entity/Entities/Property/Property";
import { Unit } from "../../../Entity/Entities/Unit/Unit";
import { Charge } from "../../../Entity/Entities/Charge/Charge";
import { Event } from "../../../Entity/Entities/Event/Event";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { Attachment } from "../../Partials/Attachment/Attachment";
import Conversation from "../../Partials/Conversation/Conversation";
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CircularProgress from '@material-ui/core/CircularProgress';
import { CoachDialogNewExecutor } from "../../Partials/Dialog/CoachDialogNewExecutor";
import TaskCard from "../../Partials/Task/TaskCard";
import EntityLaunchpanel from "../../Partials/Launchpanel/EntityLaunchpanel";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from "../../Partials/Material/TextField";
import { Company } from "../../../Entity/Entities/Company/Company";
import { Person } from "../../../Entity/Entities/Person/Person";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";

class TaskUpdate extends Component {
  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.GLOBAL_EVENT_UPDATE_CLEAR;
  protected person: PersonInterface;
  protected middlewares: MiddlewareInterface[] = [
    EventUpdateWillMount,
    PreventPageLeave
  ];

  public state = {
    task: null,
    instructions: "",
    details: "",
    executorId: null,
    contactId: null,
    executor: null,
    contact: null,
    executionDate: new Date(),
    reacted: false,
    attachments: [],
    events: [],
    fetchingEvents: true,
    removed: false,
    amazonFolderName: "",
    hasModifiedData: false,
    reated: false,
    isFinishTaskPopupOpen: false,
    isUnFinishTaskPopupOpen: false,
    currentTaskUnit: "",
    currentTaskProperty: "",
    currentTaskCharge: "",
    currentTaskEvent: "",
    createdBy: null,
    isUpdateTaskPreprocessPopupOpen: false,
    isSaving: false,
    nextPath: "",
    openLeavePrompt: false,
    reporterId: null,
    reporter: null,
    selectedEntityForTask: null,
    selectedEntityForTaskManuallyChanged: false,
    anchorElTask: null,
    isTaskRemovePopupOpen: false,
    taskToDelete: null,
    clickSendEmail: false,
    openPreTaskExecutorCoachDialog: false,
    openPreTaskReporterCoachDialog: false,
    executorType: "person",
    reporterType: "person",
    contactType: "person",
    executorTypeСhoose: true,
    contactTypeСhoose: true,
    reporterTypeСhoose: true,
    openTaskExecutorCoachDialog: false,
    openTaskReporterCoachDialog: false,
    openTaskContactCoachDialog: false,
    isFetchingTask: true,
    eventTypeId: 35, // task // TODO fix hardcoded value
    showReporterEmailPopup: false,
    showExecutorEmailPopup: false,
  }

  constructor(public props) {
    super(props);
  }

  public initializePage = (task: EventInterface) => {
    let state: any = {
      task: task,
      instructions: !!task && !!task.content && !!task.content.name ? task.content.name : "",
      details: !!task && !!task.content && !!task.content.details ? task.content.details : "",
      executorId: !!task ? task.executorId : null,
      executor: !!task ? task.executor : null,
      executionDate: !!task ? task.executionDate : null,
      attachments: !!task ? task.attachments : [],
      removed: !!task ? task.removed : false,
      reacted: !!task ? task.reacted : false,
      createdBy: !!task ? task.createdBy : null,
      currentTaskUnit: !!task && !!task.unit ? task.unit.displayName : "",
      currentTaskProperty: !!task && !!task.property ? task.property.displayName : "",
      currentTaskCharge: !!task && !!task.charge ? task.charge.displayName : "",
      currentTaskEvent: !!task && !!task.event ? task.event.displayName : "",
      reporterId: !!task ? task.reporterId : null,
      reporter: !!task ? task.reporter : null,
      selectedEntityForTaskManuallyChanged: false,
      isSaving: false,
      isFetchingTask: false,
      eventTypeId: task?.eventTypeId,
      contact: null,
      contactId: null,
    };

    if (!!task.property) {
      state.selectedEntityForTask = task.property;
    }

    if (!!task.unit) {
      state.selectedEntityForTask = task.unit;
    }

    if (!!task.charge) {
      state.selectedEntityForTask = task.charge;
    }

    if (!!task.event) {
      state.selectedEntityForTask = task.event;
    }

    if (!!task.chargeId) {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_FOR_CHARGE_DETAILS_PAGE,
        payload: {
          chargeId: task.chargeId,
        },
        onSuccess: (charge: ChargeInterface) => {
          this.setState({
            selectedEntityForTask: charge
          })
        }
      })
    }

    if (!!task.refersToEventId) {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_FOR_EVENT_DETAILS_PAGE,
        payload: {
          eventId: task.refersToEventId,
        },
        onSuccess: (event: EventInterface) => {
          this.setState({
            selectedEntityForTask: event
          })
        },
        onError: err => {
          console.log(err)
        },
      })
    }

    if (Object.keys(this.props.app?.savedDataBeforeRedirecting || {}).length > 0) {
      const createdExecutor = this.props.app.savedDataBeforeRedirecting.executor &&
        this.props.app.savedDataBeforeRedirecting.executor;

      const createdReporter = this.props.app.savedDataBeforeRedirecting.reporter &&
        this.props.app.savedDataBeforeRedirecting.reporter;

      state = {
        ...this.props.app.savedDataBeforeRedirecting.taskUpdateDataToBeSaved,
      };

      if (!!createdExecutor) {
        state.executorId = createdExecutor.id;
      }

      if (!!createdReporter) {
        state.reporterId = createdReporter.id;
      }
    }

    this.setState({ ...state }, () => {
      this.props.dispatch({
        type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
      });
    });
  }

  public fetchEntityEvents = (entityId: number) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        refersToEventId: entityId,
        removed: 0
      },
      onSuccess: data => {
        this.setState({ events: [...data.events], fetchingEvents: false });
      },
      onError: err => {
        console.log(err)
      },
    });
  }

  public setTaskName = (event) => {
    const name = event.target.value;

    this.setState({
      instructions: name,
      hasModifiedData: true
    });
  }

  public selectPerson = (executor: PersonInterface | CompanyInterface): void => {
    if (executor instanceof Company && !executor.generalContact) {
      this.setState({
        showExecutorEmailPopup: true
      })
    }

    this.setState({
      executorId: executor instanceof Person
        ? executor.id
        : executor instanceof Company && executor.generalContact?.id
          ? executor.generalContact?.id
          : null,
      executor,
      hasModifiedData: executor instanceof Person || (executor instanceof Company && executor.generalContact),
    });
  }

  public clearPerson = (): void => {
    this.setState({
      executorId: null,
      executor: null,
      hasModifiedData: true
    });
  }

  public selectReporter = (reporter: PersonInterface | CompanyInterface): void => {
    if (reporter instanceof Company && (!reporter.generalContact)) {
      this.setState({
        showReporterEmailPopup: true
      })
    }
    this.setState({
      reporterId: reporter instanceof Person
        ? reporter.id
        : reporter instanceof Company && reporter.generalContact?.id
          ? reporter.generalContact?.id
          : null,
      reporter,
      hasModifiedData: reporter instanceof Person || (reporter instanceof Company && reporter.generalContact),
    });
  }

  public clearReporter = (): void => {
    this.setState({
      reporterId: null,
      reporter: null,
      hasModifiedData: true
    });
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    this.setState({
      [identifier]: date,
      hasModifiedData: true
    });
  }

  public selectEntityForTask = (entity: PropertyInterface | UnitInterface): void => {
    this.setState({
      selectedEntityForTaskManuallyChanged: true,
      selectedEntityForTask: entity,
      hasModifiedData: true
    });
  }

  public clearEntityForTask = (): void => {
    this.setState({
      selectedEntityForTask: null,
      hasModifiedData: true
    });
  }

  public changeStatus = (): void => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_UPDATE_START,
        payload: {
          ...this.state.task.data,
          reacted: !this.state.reacted,
          content: this.state.task && this.state.task.content ? this.state.task.content : {}
        },
        onSuccess: (task) => {
          this.setState({
            isSaving: false,
            reacted: task?.reacted
          });
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public save = (notRedirect?: boolean) => {
    const task: any = {
      id: !!this.state.task && this.state.task.id,
      content: {
        name: this.state.instructions,
        details: this.state.details,
      },
      executorId: this.state.executorId,
      executionDate: this.state.executionDate ? Time.formatOrNull(this.state.executionDate) : null,
      snoozeDate: this.state.executionDate ? Time.formatOrNull(this.state.executionDate) : null,
      reporterId: this.state.reporterId,
      eventTypeId: this.state.eventTypeId,
      reacted: this.state.reacted
    };

    if (this.state.selectedEntityForTask instanceof Property) {
      task.propertyId = this.state.selectedEntityForTask.id;
    }

    if (this.state.selectedEntityForTask instanceof Unit) {
      task.unitId = this.state.selectedEntityForTask.id;
    }

    if (this.state.selectedEntityForTask instanceof Charge) {
      task.chargeId = this.state.selectedEntityForTask.id;
    }

    if (this.state.selectedEntityForTask instanceof Event) {
      task.eventId = this.state.selectedEntityForTask.id;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_UPDATE_START,
        payload: {
          ...task, clickSendEmail: this.state.clickSendEmail
        },
        onSuccess: () => {
          // const executor = this.props.app.persons.filter((person: PersonInterface) => person.id === this.state.executorId)[0];

          // if (!!executor && !executor.email) {
          // this.setState({
          // isSaving: false
          // });

          //   return this.props.dispatch({
          //     type: Constants.SNACKBAR_ADD_MESSAGE,
          //     payload: {
          //       message: this.trans("postprocess/taskupdate-hint"),
          //       type: "info"
          //     }
          //   });
          // } else {
          if (notRedirect) {
            return;
          }

          if (this.state.nextPath) {
            return this.redirect(this.state.nextPath);
          }

          if (this.state.clickSendEmail) {
            this.redirect(`/app/email/send/task/${this.state.task && this.state.task.id}`)
          } else {
            this.redirectBack();
          }
          // }
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false
          });
        }
      });
    });
  }

  protected openTaskMenu = (event: any, task): void => {
    this.setState({
      task: task,
      anchorElTask: event.currentTarget
    });
  }

  protected closeTaskMenu = (): void => {
    this.setState({
      anchorElTask: null
    });
  }

  public deleteTask = (task) => {
    this.setState({
      isSaving: true
    })

    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_DELETE_START,
      payload: {
        event: task
      },
      onSuccess: () => {
        this.setState({
          isSaving: false,
          hasModifiedData: false
        }, this.redirectBack)
      },
      onError: () => {
        this.setState({
          isSaving: false
        })
      }
    });
  }

  public getCoachContent = () => {
    return (
      <div>
        <div>
          {this.trans("coach/executor-scenario/company-step/first-info1")}
        </div>
        <div>
          <RadioGroup
            className="filters-container"
            value={this.state.executorType}
            onChange={this.chooseExecutorType}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              padding: "10px 0 0 10px",
              width: "500px",
              paddingLeft: "0px"
            }}
          >
            {/* <FormControlLabel
              control={<Radio color="primary" />}
              value="user"
              label={this.trans("coach/executor-radiobutton/user")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            /> */}
            <FormControlLabel
              control={<Radio color="primary" />}
              value="person"
              label={this.trans("coach/executor-radiobutton/person")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="company"
              label={this.trans("coach/executor-radiobutton/company")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="department"
              label={this.trans("coach/executor-radiobutton/department")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
          </RadioGroup>
        </div>
        {/* <div>
          {this.trans("coach/executor-scenario/company-step/first-info2")}
        </div> */}
      </div>
    )
  }

  public getReporterCoachContent = () => {
    return (
      <div>
        <div>
          {this.trans("coach/reporter-scenario/company-step/first-info1")}
        </div>
        <div>
          <RadioGroup
            className="filters-container"
            value={this.state.reporterType}
            onChange={this.chooseReporterType}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              padding: "10px 0 0 10px",
              width: "500px",
              paddingLeft: "0px"
            }}
          >
            {/* <FormControlLabel
              control={<Radio color="primary" />}
              value="user"
              label={this.trans("coach/executor-radiobutton/user")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            /> */}
            <FormControlLabel
              control={<Radio color="primary" />}
              value="person"
              label={this.trans("coach/executor-radiobutton/person")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="company"
              label={this.trans("coach/executor-radiobutton/company")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="department"
              label={this.trans("coach/executor-radiobutton/department")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
          </RadioGroup>
        </div>
        {/* <div>
          {this.trans("coach/executor-scenario/company-step/first-info2")}
        </div> */}
      </div>
    )
  }

  public getContactCoachContent = (role: string) => {
    const companyName = role === 'reporter' ? this.state.reporter?.displayName : this.state.executor?.displayName

    return (
      <div>
        <div>
          {this.trans("coach/create-contact-for-company", { companyName })}
        </div>
        <div>
          <RadioGroup
            className="filters-container"
            value={this.state.contactType}
            onChange={this.chooseContactType}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              padding: "10px 0 0 10px",
              width: "500px",
              paddingLeft: "0px"
            }}
          >
            <FormControlLabel
              control={<Radio color="primary" />}
              value="person"
              label={this.trans("coach/executor-radiobutton/person")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="department"
              label={this.trans("coach/executor-radiobutton/department")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
          </RadioGroup>
        </div>

        {this.state.contactType === "person" && (
          <div className="coach-content-wrapper">
            <div className="info-next">{this.trans("coach/executor-scenario/person-step/second-info1")}</div>
            <div>
              <TextField
                autoComplete="off"
                // id="firstName"
                // name="firstName"
                className="form-element full-size"
                type="text"
                label={this.trans("coach/propertyowner-scenario/person-step/second-field/firstname-label")}
                value={this.state.contact?.firstName}
                onChange={(e) => this.setState({ contact: { ...this.state.contact, firstName: e.target.value } })}
                autoFocus={true}
                variant="standard"
                error={this.state.contact?.firstNameError || this.getErrorFor("contacts.firstName") || this.getErrorFor("firstName")}
              />
              {!!this.getErrorFor("contacts.firstName") || !!this.getErrorFor("firstName") ? <div className="component-error-text">{this.getErrorFor("contacts.firstName") ? this.getErrorFor("contacts.firstName") : this.getErrorFor("firstName")}</div> : this.state.contact?.firstNameError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}

              <TextField
                autoComplete="off"
                // id="lastName"
                // name="lastName"
                className="form-element full-size"
                type="text"
                label={this.trans("coach/executor-scenario/person-step/second-field/lastname-label") + this.trans("field/optional")}
                value={this.state.contact?.lastName}
                onChange={(e) => this.setState({ contact: { ...this.state.contact, lastName: e.target.value } })}
                variant="standard"
                error={!!this.getErrorFor("lastName")}
              />
              {!!this.getErrorFor("lastName") && <div className="component-error-text">{this.getErrorFor("lastName")}</div>}
              {

              }
              <TextField
                autoComplete="off"
                className="form-element full-size"
                label={`${this.trans("coach/executor-scenario/person-step/second-field/email-label")} ${this.state.contact?.type === "person" ? this.trans("field/optional") : ""}`}
                value={this.state.contact?.email}
                onChange={(e) => this.setState({ contact: { ...this.state.contact, email: e.target.value } })}
                variant="standard"
                error={!!this.getErrorFor("email") || !!this.getErrorFor("contacts.email")}
              />
              {!!this.getErrorFor("email") && <div className="component-error-text">{this.getErrorFor("email")}</div>}

              <div>
                <TextField
                  autoComplete="off"
                  // id="phone1"
                  //name="phone1"
                  className="form-element full-size"
                  type="text"
                  label={this.trans("phone") + this.trans("field/optional")}
                  value={this.state.contact?.phone1}
                  onChange={(e) => this.setState({ contact: { ...this.state.contact, phone1: e.target.value } })}
                  variant="standard"
                  error={!!this.getErrorFor("phone1")}
                />
                {!!this.getErrorFor("phone1") && <div className="component-error-text">{this.getErrorFor("phone1")}</div>}
              </div>
            </div>
          </div>
        )}

        {this.state.contactType === "department" && (
          <div className="coach-content-wrapper">
            <div className="info-text">
              {this.trans("coach/executor-scenario/department-step/second-info1")}
            </div>

            <TextField
              autoComplete="off"
              // id="firstName"
              // name="firstName"
              className="form-element full-size"
              type="text"
              label={this.trans("coach/poaowner-scenario/company-step/second-field/department-label")}
              value={this.state.contact?.firstName}
              onChange={(e) => this.setState({ contact: { ...this.state.contact, firstName: e.target.value } })}
              variant="standard"
              error={this.state.contact?.firstNameError || this.getErrorFor("contacts.firstName")}
            />
            {!!this.getErrorFor("contacts.firstName") ? <div className="component-error-text">{this.getErrorFor("contacts.firstName")}</div> : this.state.contact?.firstNameError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}

            <TextField
              autoComplete="off"
              className="form-element full-size"
              label={this.trans("label-email") + this.trans("field/optional")}
              value={this.state.contact?.email}
              onChange={(e) => this.setState({ contact: { ...this.state.contact, email: e.target.value } })}
              variant="standard"
              error={!!this.getErrorFor("email") || !!this.getErrorFor("contacts.email")}
            />
            {!!this.getErrorFor("email") && <div className="component-error-text">{this.getErrorFor("email")}</div>}
            <div>
              <TextField
                autoComplete="off"
                // id="phone1"
                //name="phone1"
                className="form-element full-size"
                type="text"
                label={this.trans("phone") + this.trans("field/optional")}
                value={this.state.contact?.phone1}
                onChange={(e) => this.setState({ contact: { ...this.state.contact, phone1: e.target.value } })}
                variant="standard"
                error={!!this.getErrorFor("phone1")}
              />
              {!!this.getErrorFor("phone1") && <div className="component-error-text">{this.getErrorFor("phone1")}</div>}
            </div>
          </div>
        )}
      </div>
    )
  }

  public chooseContactType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      contactType: choice,
      contactTypeСhoose: true
    });
  }

  public chooseExecutorType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      executorType: choice,
      executorTypeСhoose: true
    });
  }
  public chooseReporterType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      reporterType: choice,
      reporterTypeСhoose: true
    });
  }

  public onCloseCoach = () => {
    this.setState({
      openPreTaskExecutorCoachDialog: false,
      executorType: "person",
      // executorTypeСhoose: true,
      openTaskExecutorCoachDialog: false
    })
  }

  public onCloseReporterCoach = () => {
    this.setState({
      openPreTaskReporterCoachDialog: false,
      executorType: "person",
      // executorTypeСhoose: true,
      openTaskReporterCoachDialog: false
    })
  }

  public onCloseContactCoach = () => {
    this.setState({
      openPreTaskReporterCoachDialog: false,
      contactType: "person",
      // executorTypeСhoose: true,
      openTaskContactCoachDialog: false
    })
  }

  public setExecutorFromCoach = (executor) => {
    this.setState({
      executorId: executor instanceof Company ? executor.generalContactId : executor.id,
      executor,
      hasModifiedData: true,
    })
  }

  public setReporterFromCoach = (reporter) => {
    this.setState({
      reporterId: reporter instanceof Company ? reporter.generalContactId : reporter.id,
      reporter,
      hasModifiedData: true,
    })
  }

  public setContactFromCoach = (contact) => {
    this.setState({
      contactId: contact.id,
      contact,
      hasModifiedData: true,
    })
  }

  public openFirstStep = () => {
    this.setState({
      executorType: this.state.executorTypeСhoose ? this.state.executorType : "person",
      // openPreTaskExecutorCoachDialog: true,
      openTaskExecutorCoachDialog: true
    })
  }
  public openFirstContractStep = () => {
    this.setState({
      contactType: this.state.contactTypeСhoose ? this.state.contactType : "person",
      // openPreTaskExecutorCoachDialog: true,
      openTaskContactCoachDialog: true
    })
  }
  public openFirstReporterStep = () => {
    this.setState({
      reporterType: this.state.reporterTypeСhoose ? this.state.reporterType : "person",
      // openPreTaskReporterCoachDialog: true,
      openTaskReporterCoachDialog: true
    })
  }

  public openTaskExecutorCoach = () => {
    if (this.state.executorType !== "user" || this.person.role && this.person.role.getRoleId() === 6) {
      this.setState({
        // openPreTaskExecutorCoachDialog: false,
        openTaskExecutorCoachDialog: true
      })
    } else {
      this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans("coach/executor-scenario/user-step/first-error"),
          type: "error"
        }
      });
      return;
    }
  }
  public openTaskReporterCoach = () => {
    if (this.state.reporterType !== "user" || this.person.role && this.person.role.getRoleId() === 6) {
      this.setState({
        // openPreTaskReporterCoachDialog: false,
        openTaskReporterCoachDialog: true
      })
    } else {
      this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans("coach/executor-scenario/user-step/first-error"),
          type: "error"
        }
      });
      return;
    }
  }
  public saveContactForReporter = () => {
    const person = {
      firstName: this.state.contact?.firstName,
      lastName: this.state.contact?.lastName,
      profession: "",
      email: this.state.contact?.email,
      phone1: this.state.contact?.phone1,
      phone2: "",
      contactRoleId: 3,
      mainBankAccountId: "",
      companyId: this.state.reporter.id,
      address: {
        formattedAddress: ""
      },
      dateOfBirth: null,
      placeOfBirth: {
        formattedAddress: ""
      },
      identityNumber: "",
      identityType: 255,
      amazonFolderName: "",
      note: "",
      pageTemplate: "person",
      genderTypeId: 3,
      languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2,
      companyIds: [{ id: this.state.reporter.id, role: "" }]
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_CONTACT_PERSON_CREATE_START,
        payload: {
          person,
          id: this.state.reporter.id,
        },
        onSuccess: person => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_COMPANY_UPDATE_START,
            payload: {
              id: this.state.reporter.id,
              company: {
                ...this.state.reporter.data,
                generalContactId: person.id,
              }
            },
            onSuccess: () => {
              this.setState({
                reporter: person.company,
                contact: null,
                reporterId: person.id,
                disableButtonDuringRequest: false,
                errorFields: [],
                isSaving: false,
                showReporterEmailPopup: false,
                hasModifiedData: true,
              })
            }
          })

        },
        onError: error => {
          this.setState({
            disableButtonDuringRequest: false,
            errorFields: error.fields,
            isSaving: false,
          });
        }
      });
    });
  }
  public saveContactForExecutor = () => {
    const person = {
      firstName: this.state.contact?.firstName,
      lastName: this.state.contact?.lastName,
      profession: "",
      email: this.state.contact?.email,
      phone1: this.state.contact?.phone1,
      phone2: "",
      contactRoleId: 3,
      mainBankAccountId: "",
      companyId: this.state.executor.id,
      address: {
        formattedAddress: ""
      },
      dateOfBirth: null,
      placeOfBirth: {
        formattedAddress: ""
      },
      identityNumber: "",
      identityType: 255,
      amazonFolderName: "",
      note: "",
      pageTemplate: "person",
      genderTypeId: 3,
      languageTypeId: this.props.app?.settings?.agency?.defaultLocale?.iso === 'en-US' ? 1 : 2,
      companyIds: [{ id: this.state.executor.id, role: "" }]
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_CONTACT_PERSON_CREATE_START,
        payload: {
          person,
          id: this.state.executor.id,
        },
        onSuccess: person => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_COMPANY_UPDATE_START,
            payload: {
              id: this.state.executor.id,
              company: {
                ...this.state.executor.data,
                generalContactId: person.id,
              }
            },
            onSuccess: () => {
              this.setState({
                executor: person.company,
                contact: null,
                executorId: person.id,
                disableButtonDuringRequest: false,
                errorFields: [],
                isSaving: false,
                showExecutorEmailPopup: false,
                hasModifiedData: true,
              })
            }
          })

        },
        onError: error => {
          this.setState({
            disableButtonDuringRequest: false,
            errorFields: error.fields,
            isSaving: false,

          });
        }
      });
    });
  }

  public updateEventTypeId = (event) => {
    const eventTypeId = event.target.value;

    return this.setState({
      eventTypeId: eventTypeId,
      hasModifiedData: true
    });
  }
  public getReporterDisplayName = () => {
    let reporterDisplayName

    switch (true) {
      case this.state.reporter instanceof Company:
        reporterDisplayName = this.state.reporter?.generalContact ? `${this.state.reporter?.generalContact?.displayName?.trim()} (${this.state.reporter.name})` : `${this.state.reporter.name}`
        break;
      case !!this.state.reporter?.company:
        reporterDisplayName = this.state.reporter?.displayName ? `${this.state.reporter?.displayName?.trim()} (${this.state.reporter.company.name})` : `${this.state.reporter.company.name}`
        break;
      case this.state.reporter instanceof Person:
        reporterDisplayName = `${this.state.reporter?.displayName}`
        break;
      default:
        reporterDisplayName = ""
        break;
    }

    return reporterDisplayName
  }
  public getExecutorDisplayName = () => {
    let executorDisplayName
    switch (true) {
      case this.state.executor instanceof Company:
        executorDisplayName = this.state.executor.generalContact ? `${this.state.executor.generalContact?.displayName?.trim()} (${this.state.executor.name})`: `${this.state.executor.name}`
        break;
      case !!this.state.executor?.company:
        executorDisplayName = this.state.executor?.displayName ? `${this.state.executor?.displayName?.trim()} (${this.state.executor.company.name})` : `${this.state.executor.company.name}`
        break;
      case this.state.executor instanceof Person:
        executorDisplayName = `${this.state.executor?.displayName}`
        break;
      default:
        executorDisplayName = ""
        break;
    }

    return executorDisplayName
  }

  public render() {
    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <h1>{this.trans("task")}</h1>
              <div className="button-container-small">
                {
                  this.state.hasModifiedData && (
                    <Button
                      color="primary"
                      onClick={this.redirectBack}
                      style={{ marginRight: "20px" }}
                      disabled={this.state.isSaving}
                    >
                      {this.trans("button-cancel")}
                    </Button>
                  )
                }
                <Button
                  variant="contained"
                  color="primary"
                  onClick={!this.state.hasModifiedData ? this.redirectBack : () => this.save()}
                  disabled={this.state.isSaving}
                >
                  {this.state.hasModifiedData ? this.trans("button-save") : this.trans("label-done")}
                </Button>
                {
                  <div className="three-dot-entity-menu">
                    <IconButton
                      onClick={e => this.openTaskMenu(e, this.state.task)}
                    >
                      <div className="icon icon-ic-more-vert"></div>
                    </IconButton>
                    <Menu
                      id="simple-menu"
                      anchorEl={this.state.anchorElTask}
                      open={Boolean(this.state.anchorElTask)}
                      onClose={this.closeTaskMenu}
                      disableAutoFocusItem={true}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center"
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left"
                      }}
                      getContentAnchorEl={null}
                    >
                      <MenuItem
                        onClick={() => {
                          this.setState({
                            hasModifiedData: false,
                            anchorElTask: null,
                            clickSendEmail: true
                          }, () => {
                            this.save();
                          });
                        }}
                      >
                        <ListItemIcon><div className="icon icon-ic-email"></div></ListItemIcon>
                        <ListItemText>{this.trans("page/taskupdate-link/sendinvoice")}</ListItemText>
                      </MenuItem>
                      {
                        <MenuItem
                          className="delete-action"
                          onClick={() => this.setState({
                            isTaskRemovePopupOpen: true,
                            taskToDelete: this.state.task,
                            anchorElTask: null
                          })
                          }
                        >
                          <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                          <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                        </MenuItem>
                      }
                    </Menu>
                  </div>
                }
              </div>
            </div>
          </div>

          <div className="box component-task-update">
            <div className="component-wrapper no-margin-top" style={{ paddingBottom: "15px", backgroundColor: "white" }}>
              <div className="component">
                {
                  this.state.isFetchingTask && (
                    <div style={{ position: "relative", height: "60px" }}>
                      <div className="component-spinner-wrapper">
                        <CircularProgress />
                      </div>
                    </div>
                  )
                }
                {
                  !this.state.isFetchingTask && this.state.task && (
                    <TaskCard
                      {...this.props}
                      task={this.state.task}
                      reporterDisplayName={this.getReporterDisplayName()}
                      executorDisplayName={this.getExecutorDisplayName()}
                      reporter={this.state.reporter}
                      executor={this.state.executor}
                      reacted={this.state.reacted}
                      changeStatus={this.changeStatus}
                      selectedEntityForTask={this.state.selectedEntityForTask}
                      eventTypeId={this.state.eventTypeId}
                      updateEventTypeId={this.updateEventTypeId}
                      instructions={this.state.instructions}
                      setTaskName={this.setTaskName}
                      reporterId={this.state.reporterId}
                      selectReporter={this.selectReporter}
                      clearReporter={this.clearReporter}
                      executorId={this.state.executorId}
                      selectPerson={this.selectPerson}
                      clearPerson={this.clearPerson}
                      executionDate={this.state.executionDate}
                      selectDate={this.selectDate}
                      removed={this.state.removed}
                      selectEntityForTask={this.selectEntityForTask}
                      clearEntityForTask={this.clearEntityForTask}
                      openTaskExecutorCoachDialog={() => this.setState({
                        openTaskExecutorCoachDialog: true
                      })}
                      openTaskReporterCoachDialog={() => this.setState({
                        openTaskReporterCoachDialog: true
                      })}
                    />
                  )
                }
              </div>
            </div>

            {
              this.state.task?.conversationId && (
                <div className="component-wrapper">
                  <Conversation
                    {...this.props}
                    entity={this.state.task}
                    conversation={this.props.app.conversations.find(c=>c.id === this.state.task?.conversationId)}
                    withoutBottomMargin={true}
                  />
                </div>
              )}

            {/* <div className="component-wrapper">
              <Conversation
                {...this.props}
                entity={this.state.task}
                withoutBottomMargin={true}
              />
            </div> */}

            <div className="component-wrapper no-shadow">
              <Attachment
                {...this.props}
                typeOfComponent="shared"
                title={this.trans("attachments-for-task")}
                amazonFolderName={this.state.amazonFolderName}
                relation="eventId"
                entity={this.state.task}
                onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
                updateParentState={attachments => this.setState({ attachments: attachments })}
                disabled={this.state.removed || this.state.reated}
                attachments={this.state.attachments}
              />
            </div>
          </div>
          <div className={"right-panel-wrapper"}>
            {!this.state.removed && (
              <EntityLaunchpanel
                {...this.props}
                entityTitle={this.trans("launchpanel-person-task")}
                actionsList={
                  <List component="div" disablePadding>
                    <ListItem
                      button
                      key={`send_payment_by_email`}
                      alignItems="flex-start"
                      onClick={() => {
                        if (this.state.hasModifiedData) {
                          this.setState({
                            isErrorLaunchPanelOpen: true,
                            anchorPaymentEl: null,
                            openLeavePrompt: true
                          })
                        } else {
                          this.setState({
                            hasModifiedData: false,
                            anchorPaymentEl: null
                          }, () => {
                            this.redirect(`/app/email/send/task/${this.state.task && this.state.task.id}`);
                          })
                        }
                      }}
                      style={{ padding: "1px 16px" }}
                    >
                      <ListItemIcon><div className="icon icon-style-launch-panel icon-ic-email"></div></ListItemIcon>
                      <ListItemText primary={this.trans("launch-panel-send-payment-by-email")} secondary={this.trans("hint/launch-panel-send-task-by-email")} />
                    </ListItem>
                  </List>
                }
              />
            )}
            {this.isBeta() &&
              <Timeline
                {...this.props}
                relations={{ refersToEventId: this.state.task && this.state.task.id }}
                entityEvents={this.state.events}
                fetchEntityEvents={this.fetchEntityEvents.bind(this, this.state.task && this.state.task.id)}
                fetchingEvents={this.state.fetchingEvents}
              />
            }
          </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention") + "!"}
          content={this.trans("preprocess/taskupdate-hint")}
          prioritizeClosing={true}
          openLeavePrompt={this.state.isUpdateTaskPreprocessPopupOpen}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-continue")}
          onDiscard={() => this.setState({ isUpdateTaskPreprocessPopupOpen: false })}
          onSave={() => this.setState({ isUpdateTaskPreprocessPopupOpen: false }, this.save)}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("delete-task")}
          content={this.trans("you-are-about-to-delete-task", { name: this.state.task && this.state.task.name ? this.state.task.name : "" })}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-remove")}
          openLeavePrompt={this.state.isTaskRemovePopupOpen}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isTaskRemovePopupOpen: false }); }}
          onSave={() => { this.setState({ isTaskRemovePopupOpen: false }, () => this.deleteTask(this.state.task)); }}
          positiveButtonStyle={{ backgroundColor: "red" }}
          hideCross={true}
        />

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <CoachDialogNewExecutor
          {...this.props}
          openTaskExecutorCoachDialog={this.state.openTaskExecutorCoachDialog}
          type={this.state.executorType}
          setExecutor={this.setExecutorFromCoach}
          openFirstStep={this.openFirstStep}
          onCloseCoach={this.onCloseCoach}
          firstStep={this.getCoachContent}
        />
        <CoachDialogNewExecutor
          {...this.props}
          openTaskExecutorCoachDialog={this.state.openTaskReporterCoachDialog}
          type={this.state.reporterType}
          setExecutor={this.setReporterFromCoach}
          openFirstStep={this.openFirstReporterStep}
          onCloseCoach={this.onCloseReporterCoach}
          firstStep={this.getReporterCoachContent}
        />

        <PromptDialog
          {...this.props}
          // title={this.trans("coach/create-contact-for-company", { companyName: this.state.reporter?.displayName})}
          content={this.getContactCoachContent("reporter")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          positiveButtonLabel={this.trans("button-save")}
          openLeavePrompt={this.state.showReporterEmailPopup}
          prioritizeClosing={true}
          // innerDialogClasses="dialog-assistant coach-executor"
          innerDialogClasses="dialog-create-task"
          onDiscard={() => {
            this.setState({
              showReporterEmailPopup: false,
              reporter: null,
              contact: null,
            });
          }}
          onSave={this.saveContactForReporter}
        />
        <PromptDialog
          {...this.props}
          // title={this.trans("coach/create-contact-for-company", { companyName: this.state.reporter?.displayName})}
          content={this.getContactCoachContent("executor")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          positiveButtonLabel={this.trans("button-save")}
          openLeavePrompt={this.state.showExecutorEmailPopup}
          prioritizeClosing={true}
          // innerDialogClasses="dialog-assistant coach-executor"
          innerDialogClasses="dialog-create-task"
          onDiscard={() => {
            this.setState({
              showExecutorEmailPopup: false,
              executor: null,
              contact: null,
            });
          }}
          onSave={this.saveContactForExecutor}
        />
        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    properties: state.properties,
    units: state.units,
    events: state.events,
    component: state.eventUpdate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  TaskUpdate
);
